<!-- Viewing the tickets assigned to expert for analysis-->
<!-- checking role is TechExpert-->
<ng-container *ngIf="role && role !== 'TECHEXPERT'">
    <h1>UNAUTHORISED ACCESS</h1> <br>
    <h3>Please Login as TECHEXPERT, redirecting ...</h3>
    {{unauthorised()}}
  </ng-container>

  <ng-container *ngIf="role && role === 'TECHEXPERT'">
    <div class="wrapper ">
      <div>
        <div class="content">
          <ng-container>
          <div style=" text-align: center;">
            <form [formGroup]="filterForm" style="padding-left: 4em; padding-right: 4em; padding-top: 2em;">
              <mat-form-field appearance="fill">
                <mat-label id="head">Created Between: </mat-label>
                <mat-date-range-input [rangePicker]="picker" >
                  <input formControlName="startDate" matStartDate placeholder="Start date" required>
                  <input formControlName="endDate" matEndDate placeholder="End date" required>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>&nbsp;&nbsp;
            <button type="button" class="btn btn-success" (click)="filter()">FILTER</button>&nbsp;&nbsp;
            <button type="button" class="btn btn-warn" (click)="reset()">RESET</button>
          </form>
          </div>
        </ng-container><br>

          <ng-container *ngIf="pending">
            <div class="alert alert-danger" role="alert" *ngIf="pending.length === 0">
              No Pending Tickets
            </div>
            <div class="alert alert-primary" role="alert" *ngIf="pending.length !== 0">
              Your Pending Tickets
            </div>
            <div class="card">
              <div class="card-body">
            <table class="table table-hover" *ngIf="pending.length !== 0">
              <thead class=" text-primary">
                <tr>
                  <th scope="col">Ticket No</th>
                   <th scope="col">Customer</th>
                  <th scope="col">Message</th>
                  <th scope="col">See Conversation</th>
                  <th scope="col">Created On</th>
                  <th scope="col">Updated On</th>
                  <th scope="col">Actions</th>
                  <!-- <th scope="col">REPLY</th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ticket of pending">
                  <td>{{ ticket._id }}</td>
                   <td>{{ ticket.customer.fullName }}</td>
                  <td>
                    <div *ngIf="ticket.message[0]">{{ ticket.message[0]['message'] }}</div>
                    <div *ngIf="!ticket.message[0]">NO MESSAGE TO DISPLAY</div>
                  </td>
                  <td>
                    <button class="btn btn-lg btn-outline-primary" (click)="openChat(mychatmodal, ticket.message, ticket._id)">See Chat</button>
                  </td>
                  <td>{{ transformDate(ticket.createdAt) }}</td>
                  <td>{{ transformDate(ticket.updatedAt) }}</td>
                  <td>
                  <button type="button" class="btn btn-success" (click)="sendCurveDataToAnalyser(ticket.curveData, ticket.heatNumber)">View Curve</button>
                     <!-- <button class="btn btn-warn" (click)="openAllAttachments(viewattachmentmodal,ticket._id)">View attachment</button> -->
                  </td>
                  <!-- <td><button type="button" class="btn btn-outline-primary" (click)="repltToTicket(ticket)">Reply</button></td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
          </ng-container>
          <ng-container *ngIf="resolved">
            <div class="alert alert-danger" role="alert" *ngIf="resolved.length === 0">
              No Closed Ticket
            </div>
            <div class="alert alert-primary" role="alert" *ngIf="resolved.length !== 0">
              Your Closed Tickets
            </div>
            <div class="card">
              <div class="card-body">
            <table class="table table-hover" *ngIf="resolved.length !== 0">
              <thead class=" text-primary">
                <tr>
                  <th scope="col">Ticket ID</th>
                  <th scope="col">Customer</th>
                  <th scope="col">Message</th>
                  <th scope="col">See Conversation</th>
                  <th scope="col">Created On</th>
                  <th scope="col">Updated On</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ticket of resolved">
                  <td>{{ ticket._id }}</td>
                  <td *ngIf="ticket.customer">{{ ticket.customer.fullName }}</td>
                  <td *ngIf="!ticket.customer">Details unavailable</td>
                  <td>
                    <div *ngIf="ticket.message[0]">{{ ticket.message[0]['message'] }}</div>
                    <div *ngIf="!ticket.message[0]">NO MESSAGE TO DISPLAY</div>
                  </td>
                  <td>
                    <button class="btn btn-lg btn-outline-primary" (click)="openChat(mychatmodal, ticket.message, ticket._id)">See Chat</button>
                  </td>
                  <td>{{ transformDate(ticket.createdAt) }}</td>
                  <td>{{ transformDate(ticket.updatedAt) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
          </ng-container>
          <ng-container *ngIf="tickets">
            <div class="alert alert-danger" role="alert" *ngIf="pending.length === 0">
              No Tickets history
            </div>
            <div class="alert alert-primary" role="alert" *ngIf="pending.length !== 0">
              All Your Tickets
            </div>
            <div class="card">
              <div class="card-body">
            <table class="table table-hover" *ngIf="pending.length !== 0">
              <thead class=" text-primary">
                <tr>
                  <th scope="col">Ticket ID</th>
                  <th scope="col">Customer</th>
                  <th scope="col" class="message-header">Message</th>
                  <th scope="col">See Conversation</th>
                  <th scope="col">Created On</th>
                  <th scope="col">Updated On</th>
                  <th scope="col">Actions</th>
                  <!-- <th scope="col">REPLY</th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ticket of tickets">
                  <td>{{ ticket._id }}</td>
                  <td>
                  <div *ngIf="!ticket.customer">DETAILS UNAVAILABLE</div>
                  <div *ngIf="ticket.customer">{{ ticket.customer.fullName }}</div>
                </td>
                  <td>
                    <div *ngIf="ticket.message[0]">{{ ticket.message[0]['message'] }}</div>
                    <div *ngIf="!ticket.message[0]">NO MESSAGE TO DISPLAY</div>
                  </td>
                  <td>
                    <button class="btn btn-outline-primary" (click)="openChat(mychatmodal, ticket.message, ticket._id)">See Chat</button>
                  </td>
                  <td>{{ transformDate(ticket.createdAt) }}</td>
                  <td>{{ transformDate(ticket.updatedAt) }}</td>
                  <td>
                    <button type="button" class="btn btn-success" (click)="sendCurveDataToAnalyser(ticket.curveData , ticket.heatNumber)">View Curve</button>
                    <!-- <button class="btn btn-warn" (click)="openAllAttachments(viewattachmentmodal,ticket._id)">View attachment</button> -->
                  </td>
                  <!-- <td><button type="button" class="btn btn-outline-primary" (click)="repltToTicket(ticket)">Reply</button></td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
          </ng-container>
        </div>
      </div>
    </div>




    <ng-template #mychatmodal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">See the chat with expert and customer</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
        <div class="modal-body">
          <div class="blinking"><p>After sending message<br>Refresh the page for display of reply message !!!</p></div>
          <div id="container">
            <main>
              <ul id="chat">
                <div *ngFor='let message of messages'>
                  <div *ngIf="message.verified === true">
                    <div *ngIf="message.role === 'TECHEXPERT'">
                      <li class="me">
                        <div class="entete">
                          <span class="status green"></span>
                          <h2>YOU</h2>
                          <h3> | {{transformDate(message.createdAt)}}</h3>
                        </div>
                        <div class="triangle"></div>
                        <div class="message">
                          {{message.message}}
                        </div>
                      </li>
                    </div>
                    <div *ngIf="message.role === 'CUSTOMER'">
                      <li class="you">
                        <div class="entete">
                          <h3>{{transformDate(message.createdAt)}} | </h3>
                          <h2>Customer</h2>
                          <span class="status blue"></span>
                        </div>
                        <div class="triangle"></div>
                        <div class="message">
                          {{message.message}}
                        </div>
                      </li>
                    </div>
                  </div>

                </div>
              </ul>
              <footer>
                <form [formGroup]="ticketReplyForm" (submit)="replyToTicket()">
                  <textarea formControlName="message" rows="3" style="width:100%;" (ngModelChange)="checkIfEmail($event)" placeholder="Type your message" required></textarea>
                  <button type="submit" [disabled]="ticketReplyForm.controls['message'].invalid && ticketReplyForm.controls['message'].errors.required">
                    <!-- <mat-icon *ngIf="disableButton"  [matTooltipPosition]="position" matTooltip="Please Remove Personal Info">send</mat-icon> -->
                    <!-- *ngIf="!disableButton"  -->
                    <mat-icon (click)="modal.dismiss('save click')">send</mat-icon>
                  </button>
                  <!--   <button class="attachment" type="button"[disabled]="ticketReplyForm.controls['message'].invalid && ticketReplyForm.controls['message'].errors.required" (click)="openattachment(attachmentmodal)" >add attachment</button>
                <label *ngIf="checkButton" class="validation-message">
                    Please Remove Personal Info[Admins are notified]
                  </label> -->
                  <div *ngIf="ticketReplyForm.controls['message'].invalid" style="margin-top: 20px;">
                    <label *ngIf="ticketReplyForm.controls['message'].errors.required" class="validation-message">
                    Please enter a message first, then proceed to sending your message or attaching any files.
                    </label>
                  </div>
                </form>
              </footer>
            </main>
          </div>
        </div>
        <!--Add Image-->
        <div class="modal-footer">
          Your communication is not end-to-end encrypted
        </div>
    </ng-template>



    <ng-template #attachmentmodal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-attachment-title">Add an attachment</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <!-- (submit)="saveTicket()" [formGroup]="ticketForm" -->
      <form>
        <div class="modal-body" style="margin: 0 auto;">

          <div class="columns">
            <div class="column is-one-third">
              <div class="field">
                <div class="file has-name is-primary is-fullwidth">
                <!--  <label class="file-label">
                    <input
                      class="file-input"
                      type="file"
                      name="file"
                      #fileInput
                      (change)="onChange(fileInput.files[0])"
                    />

                  </label>-->
                </div>
              </div>

            </div>
            <div class="column">
              <figure *ngIf="imageUrl!=''">
                <img height="300" width="300" [src]="imageUrl" />
              </figure>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-outline-dark" (click)="modal.dismiss('added attachments')">Add attachment</button>
        </div>
        </form>
        </ng-template>


        <ng-template #viewattachmentmodal let-modal>
          <div class="modal-header">
         <!------   <h4 class="modal-title" id="modal-view-attachment-title">View attachments</h4> --->
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <!-- (submit)="saveTicket()" [formGroup]="ticketForm" -->
          <form>
            <div class="modal-body" style="margin: 0 auto;" *ngIf="attachments.length==0">
             No attachments to display

            </div>
            <div class="modal-body" style="margin: 0 auto;" *ngIf="attachments.length!=0">
               <ul *ngFor="let attachment of attachments">

                <div *ngIf="attachment.role && attachment.role=='CUSTOMER'">
                  <p>Customer attachment : </p>
                  <li id="attachment.file"><a href="{{environment.apiBaseUrl+'/get-attachment/' + attachment.file }}" target="_blank">
                            <div *ngIf="!attachment.name">
                            {{attachment.file}}
                            </div>
                            <div *ngIf="attachment.name">
                              {{attachment.name}}
                            </div>
                    </a></li>
                  </div>


                  <div *ngIf="attachment.role && attachment.role=='TECHEXPERT'">
                    <p>Expert attachment: </p>
                    <li id="attachment.file"><a href="{{environment.apiBaseUrl+'/get-attachment/' + attachment.file }}" target="_blank">
                      <div *ngIf="!attachment.name">
                      {{attachment.file}}
                      </div>
                      <div *ngIf="attachment.name">
                        {{attachment.name}}
                      </div>
                      </a></li>
                    </div>


                    <div *ngIf="!attachment.role">
                      <li id="attachment.file"><a href="{{environment.apiBaseUrl+'/get-attachment/' + attachment.file }}" target="_blank">
                        <div *ngIf="!attachment.name">
                        {{attachment.file}}
                        </div>
                        <div *ngIf="attachment.name">
                          {{attachment.name}}
                        </div>
                        </a></li>
                    </div>


               </ul>
            </div>

            </form>
            </ng-template>

  </ng-container>
<!-- end of ticket assignment display-->
